module.exports = __webpack_public_path__ + "static/media/opinionesAlba.086a9d05.jpg";